import { QuoteIcon } from "lucide-react";
import React from "react";
import { motion } from "framer-motion";

const testimonials = [
  {
    name: "Sarah",
    role: "Community Health Volunteer",
    quote:
      "Afya Ustawi Foundation helped us bring health awareness to rural families. I’ve seen real transformation in our community.",
  },
  {
    name: "Darlene",
    role: "Teacher & Mother",
    quote:
      "Through the mental health sessions, I learned how to manage stress and support my students emotionally. It’s been life-changing.",
  },
  {
    name: "Maria",
    role: "Senior Citizen",
    quote:
      "The foundation’s wellness programs kept me active and connected. I now mentor young women in my neighborhood.",
  },
  {
    name: "John",
    role: "Youth Leader",
    quote:
      "Joining the economic empowerment workshops gave me practical business skills. I started a small project that supports my family.",
  },
  {
    name: "Neema",
    role: "Environmental Activist",
    quote:
      "Tree-planting and clean water initiatives inspired me to take climate action locally. Afya Ustawi truly cares about sustainable well-being.",
  },
  {
    name: "Peter",
    role: "Health Officer",
    quote:
      "Their collaboration with local clinics improved community health outcomes — it’s an example of partnership done right.",
  },
  {
    name: "Zawadi",
    role: "University Student",
    quote:
      "Volunteering here gave me purpose and confidence. I learned teamwork, leadership, and the value of community service.",
  },
  {
    name: "Fatma",
    role: "Small Business Owner",
    quote:
      "Thanks to Afya Ustawi’s training, I grew my business and now employ two women in my village. Empowerment in action!",
  },
];

export default function TestimonialsSection() {
  return (
    <section className="bg-gray-50 py-16 px-4 sm:px-8 lg:px-16 overflow-hidden">
      <div className="max-w-7xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-10 text-maroon-700">
          What People Say
        </h2>

        {/* Scrollable container */}
        <div className="relative">
          <motion.div
            className="flex gap-6 overflow-x-auto snap-x snap-mandatory scrollbar-hide px-2 md:px-4"
            style={{ scrollBehavior: "smooth" }}
          >
            {testimonials.map((t, index) => (
              <motion.div
                key={index}
                className="flex-shrink-0 w-[85%] sm:w-[60%] md:w-[40%] mb-2 lg:w-[30%] bg-white shadow-sm rounded-2xl p-6 hover:shadow-xl transition-all duration-300 text-left snap-center"
                whileHover={{ scale: 1.03 }}
              >
                <div className="h-10 w-10 flex items-center justify-center rounded-full bg-green-100 mb-3">
                  <QuoteIcon className="w-5 h-5 text-green-700" />
                </div>
                <p className="text-gray-600 text-sm font-light md:text-base mb-4 leading-relaxed">
                  “{t.quote}”
                </p>
                <h3 className="font-semibold text-gray-900 text-sm md:text-base">
                  – {t.name}
                </h3>
                {/* Uncomment if needed */}
                {/* <p className="text-xs text-gray-500">{t.role}</p> */}
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
